export default "__VITE_ASSET__Cqc8qomc__"